import React from 'react';
import {FaFileCircleExclamation, FaLocationPin, FaTriangleExclamation} from "react-icons/fa6";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import BaseNode from "./base-node.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";
import CheckHasData from "../check-has-data.jsx";

const Bo = ({data, selected}) => {
    const navigate = navigateHook();
    const {toggleItemsNode, boName} = useEdgeBuilder();

    const icon = (
        <img
            className="m-auto"
            src={getAssetPath("img/dashboard-svg/sw.bogcm.svg")}
            alt="image"
        />
    );

    const infoBlock = () => {
        const reasons = JSON.parse(data.reasons);
        const reasonName = reasons ? reasons.map(r => r.name).join(', ') : null;

        return (
            <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
                {
                    toggleItemsNode.bo.reason &&
                    <div className={"flex items-center"}>
                        <FaFileCircleExclamation/>
                        <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                            <CheckHasData value={reasonName} />
                        </p>
                    </div>
                }
                {
                    toggleItemsNode.bo.address &&
                    <div className={"flex items-center"}>
                        <FaLocationPin/>
                        <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                            <CheckHasData value={data.address} />
                        </p>
                    </div>
                }

                {
                    toggleItemsNode.bo.flagrant &&
                    <div className={"flex items-center"}>
                        <FaTriangleExclamation/>
                        <p className={"ml-1 mb-0"}>
                            <CheckHasData value={data.flagrant} />
                        </p>
                    </div>
                }
            </div>
        )
    }

    const title = (
        <>
            <p className={"!mb-[2px]"}><b>{boName} - {data.id}</b></p>
            <p className={"mb-0 text-[6px]"}>
                <CheckHasData value={projectUtils.formatDate(data.dateTimeFactIni)} />
            </p>
        </>
    )

    const open = () => {
        const {id} = data;

        const url = `/bos/${id.replace("/", "-")}`;
        navigate(url, true);
    }

    return (
        <BaseNode
            icon={icon}
            title={title}
            image={null}
            infoBlock={infoBlock()}
            onExtraAction={open}
            onSearchConnections={true}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#c5c5c5]"}
            bgBody={"bg-[#f5f5f5]"}
        />
    );
};

export default Bo;